import { LlmChatMessageDto, LlmChatMessageRole } from '@paladin-monorepo/common';

/** True when the latest user message in the thread has an assistant reply with text or a UI action. */
export function userTurnHasAssistantTextReply(messages: LlmChatMessageDto[]): boolean {
  let lastUserIndex = -1;
  for (let i = messages.length - 1; i >= 0; i--) {
    if (messages[i].role === LlmChatMessageRole.User) {
      lastUserIndex = i;
      break;
    }
  }
  if (lastUserIndex === -1) {
    return false;
  }

  for (let i = lastUserIndex + 1; i < messages.length; i++) {
    const message = messages[i];
    if (message.role !== LlmChatMessageRole.Assistant) {
      continue;
    }
    if (message.content?.trim() || message.uiAction) {
      return true;
    }
  }
  return false;
}
